import { createContext, useContext } from 'react';

const RowContext = createContext(null);
export const RowProvider = RowContext.Provider;
export function useRowContext() {
  const context = useContext(RowContext);
  return context;
}
